export class Iconset {
    /**
     * Create a new icon set.
     *
     * @param {String} name the name for the set of icons, used by icon
     * @param {Function} resolver the function that will resolve an icon to a URI
     */
    constructor(name, resolver, mutator) {
        this.name = name;
        this.resolver = resolver;
        this.mutator = mutator;
    }
    /**
     * Get an individual icon from the set, returns URI for the icon
     */
    getIcon(name) {
        return this.resolver(name, this.name);
    }
    /**
     * Mutate or alter an svg with mutator function if it exists
     * @param svg svg to mutate
     * @param name name of the icon being mutated
     */
    mutate(svg, name) {
        if (this.mutator) {
            this.mutator(svg, name);
        }
    }
}
export class IconLibrary {
    constructor() {
        this.iconSets = new Map();
        this._defaultPath = '/static/svgs/';
        this.dispatchEvent = (name, detail) => {
            const event = new CustomEvent(name, {
                bubbles: true,
                composed: true,
                detail,
            });
            setTimeout(() => window.dispatchEvent(event), 0);
        };
    }
    static getInstance() {
        if (!IconLibrary.instance) {
            IconLibrary.instance = new IconLibrary();
        }
        return IconLibrary.instance;
    }
    get defaultPath() {
        return this._defaultPath.replace(/\/$/, '');
    }
    set defaultPath(path) {
        this._defaultPath = path;
    }
    add(name, resolver, mutator) {
        const iconset = new Iconset(name, resolver, mutator);
        this.iconSets.set(iconset.name, iconset);
        this.dispatchEvent('iconset-added', { iconset });
    }
    remove(name) {
        this.iconSets.delete(name);
        this.dispatchEvent('iconset-removed', { name });
    }
    getIconset(name) {
        return this.iconSets.get(name);
    }
}
//# sourceMappingURL=library.js.map